var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4384 10.6484C14.4384 12.9783 12.5496 14.8671 10.2197 14.8671C7.88975 14.8671 6.00098 12.9783 6.00098 10.6484C6.00098 8.31846 7.88975 6.42969 10.2197 6.42969C12.5496 6.42969 14.4384 8.31846 14.4384 10.6484Z",
    fill: "#0061ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2186 10.6484C28.2186 12.9783 26.3299 14.8671 23.9999 14.8671C21.67 14.8671 19.7812 12.9783 19.7812 10.6484C19.7812 8.31846 21.67 6.42969 23.9999 6.42969C26.3299 6.42969 28.2186 8.31846 28.2186 10.6484Z",
    fill: "#0061ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2186 24.4296C28.2186 26.7595 26.3299 28.6483 23.9999 28.6483C21.67 28.6483 19.7812 26.7595 19.7812 24.4296C19.7812 22.0997 21.67 20.2109 23.9999 20.2109C26.3299 20.2109 28.2186 22.0997 28.2186 24.4296Z",
    fill: "#0061ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4379 38.3515C14.4379 40.6814 12.5491 42.5702 10.2192 42.5702C7.88926 42.5702 6.00049 40.6814 6.00049 38.3515C6.00049 36.0216 7.88926 34.1328 10.2192 34.1328C12.5491 34.1328 14.4379 36.0216 14.4379 38.3515Z",
    fill: "#0061ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0004 10.6484C42.0004 12.9783 40.1116 14.8671 37.7817 14.8671C35.4518 14.8671 33.563 12.9783 33.563 10.6484C33.563 8.31846 35.4518 6.42969 37.7817 6.42969C40.1116 6.42969 42.0004 8.31846 42.0004 10.6484Z",
    fill: "#0061ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2186 38.3515C28.2186 40.6814 26.3299 42.5702 23.9999 42.5702C21.67 42.5702 19.7812 40.6814 19.7812 38.3515C19.7812 36.0216 21.67 34.1328 23.9999 34.1328C26.3299 34.1328 28.2186 36.0216 28.2186 38.3515Z",
    fill: "#0061ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25049 12.4766H12.1879V36.1012H8.25049V12.4766Z",
    fill: "#0061ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0317 12.4766H25.9692V36.1012H22.0317V12.4766Z",
    fill: "#0061ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7501 11.8434L39.7501 20.7207C39.7501 23.8164 37.2486 26.3303 34.153 26.3456L9.38523 26.4682L9.36573 22.5308L34.1335 22.4082C35.0622 22.4036 35.8126 21.6494 35.8126 20.7207L35.8126 11.8434L39.7501 11.8434Z",
    fill: "#0061ED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4004 37.9883H35.2871V41H33.2305V32.4688H36.5879C37.5996 32.4688 38.3906 32.6934 38.9609 33.1426C39.5312 33.5918 39.8164 34.2266 39.8164 35.0469C39.8164 35.6406 39.6953 36.1328 39.4531 36.5234C39.2148 36.9141 38.8398 37.2305 38.3281 37.4727L40.1094 40.9121V41H37.9062L36.4004 37.9883ZM35.2871 36.4004H36.5879C36.9785 36.4004 37.2715 36.2988 37.4668 36.0957C37.666 35.8887 37.7656 35.6016 37.7656 35.2344C37.7656 34.8672 37.666 34.5801 37.4668 34.373C37.2676 34.1621 36.9746 34.0566 36.5879 34.0566H35.2871V36.4004Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default ForwardRef;